import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class SeasonsImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /seasons/{seasonId}/config */
  public getSeasonsBySeasonIdConfig(seasonId: string) {
    return this.makeRequest<API.GetSeasonsConfigModel>(`seasons/${encodeURIComponent(String(seasonId))}/config`, {
      method: 'GET'
    });
  }

  /** GET /seasons/{seasonId}/user-scores */
  public getSeasonsBySeasonIdUserScores(seasonId: string) {
    return this.makeRequest<API.GetUserScoresBySeasonIndexModel[]>(
      `seasons/${encodeURIComponent(String(seasonId))}/user-scores`,
      {
        method: 'GET'
      }
    );
  }

  /** GET /seasons/{seasonId}/positions-rewards */
  public getSeasonsBySeasonIdPositionsRewards(seasonId: string) {
    return this.makeRequest<API.GetPositionsRewardsBySeasonModel | undefined>(
      `seasons/${encodeURIComponent(String(seasonId))}/positions-rewards`,
      {
        method: 'GET'
      }
    );
  }
}
